import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiSelect: {
            styleOverrides: {
                select: {
                    minHeight: '40px',
                    alignContent: 'center',
                    lineHeight: '1.285', // fix weird rounding on Chrome
                },
                icon: {
                    color: designTokens.color.gray.obsidian.value,
                    transform: 'rotate(90deg)',
                },
                iconOpen: {
                    color: designTokens.color.gray.obsidian.value,
                    transform: 'rotate(270deg)',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=selectTheme.js.map